module.exports = __webpack_public_path__ + "img/Icon-Allergies.7b179a77.svg";